import React, { Suspense } from 'react';
import styled from 'styled-components';
import { LineLoaderGipno } from './line-loader';
import { CircleLoaderGipno } from './circle-loader';

type LoaderType = 'line' | 'circle';
type LoaderWidth = number | 'expand';
type InnerPercent = "percent";
type CircleInnerType = InnerPercent | React.ReactElement | null | string;
export type Labelposition = 'top' | 'bottom' | 'left' | 'right';

export interface LoaderProps {
  value: number;
  width: LoaderWidth;
  height: number;
  innerText: CircleInnerType;
  maxValue?: number;
  label?: string;
  type?: LoaderType;
  labelposition?: Labelposition;
  colorStops?: {color: string, percent: number}[];
  fontSize?: number;
}

const Text = styled.text`
  fill: #000;
  font-size: 16px;
`;

const Percentage = styled.tspan`
  font-weight: bold;
`;

const InnerIcon = styled.div<{imgurl: string; width: number}>`
  width: ${({width}) => width + 'px'};
  height: ${({width}) => width + 'px'};
  background-image: ${({imgurl}) => (imgurl == "" ? "none" : "url(\'" + imgurl + "\')")};
  background-repeat: no-repeat;
  background-position: center center;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export function LoaderGipno (props: LoaderProps) {
  let {value, 
      width, 
      innerText, 
      height, 
      label, 
      labelposition: labelPosition, 
      type = "line", 
      maxValue = 100, 
      colorStops, 
      fontSize = 24} = props;

  const normalizedPercent = Math.max(0, Math.min(value, maxValue));
  const percent = Math.round((normalizedPercent / maxValue) * 100);

  if(!colorStops) colorStops = [{color: "#4B51EA", percent: percent}];

  let innerBlock: null | React.ReactElement;
  let iconWidth: number = 500;
  if(typeof(width) === "number") iconWidth = width / 2;

  if(innerText === 'percent') {
    innerBlock = <Text x="50" y="50">
                    <Percentage>{percent}%</Percentage>
                  </Text>;
  }
  else if(typeof(innerText) === "string") {
    innerBlock = <InnerIcon width={iconWidth} imgurl={innerText}></InnerIcon>;
  }
  else {
    innerBlock = <InnerIcon width={iconWidth} imgurl="">{innerText}</InnerIcon>;
  }

  return (
    <>
      {type === 'line' ? (
        <LineLoaderGipno fontSize={fontSize} width={width} percent={percent} height={height} 
                          colorStops={colorStops} label={label ?? ''} labelposition={labelPosition ?? "top"}/>
      ) : (
        <CircleLoaderGipno percent={percent} width={width} height={height} label={label ?? ''}  labelposition={labelPosition ?? "left"}
                          colorStops={colorStops} innerBlock={innerBlock} fontSize={fontSize}/>
      )}
    </>
  );
};
